import { SelectValue } from 'types/form'
import countryOfResidence from 'constants/countryOfResidence'

export const prepareResponseItems = <R = string>(items: SelectValue<R>[]) =>
  items.map(({ value }) => value) as R[]

const CODE_NAMES = countryOfResidence.reduce<{ [key: string]: string }>(
  (res, { code, name }) => {
    res[code] = name
    return res
  },
  {}
)

export const prepareCorForSelect = (codes?: string[]) =>
  codes?.map((code) => ({ label: CODE_NAMES[code], value: code })) || []

export const prepareSelectDataByIds = (
  ids: number[],
  data: { label: string; value: string }[]
) =>
  ids.map((code) => {
    const preparedValues = data.reduce((res, { label, value }) => {
      res[value] = label
      return res
    }, {} as { [key: string]: string })
    return { label: preparedValues[code] || '', value: String(code) }
  }) || []
